import { render } from "./AyudaElemEmpr.vue?vue&type=template&id=b1b5ca5a&scoped=true"
import script from "./AyudaElemEmpr.vue?vue&type=script&lang=js"
export * from "./AyudaElemEmpr.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=b1b5ca5a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1b5ca5a"]])

export default __exports__